import React from 'react'
import styled from 'styled-components'
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share'

import twittericon from '@/images/icon-twitter.svg'
import facebookicon from '@/images/icon-facebook.svg'
import whatsappicon from '@/images/icon-whatsapp.svg'

const BorderRed = styled.span`
  display: block;
  margin: 10px auto;
  width: 0;
  border-left: 1px solid #b10925;
  height: 24px;
`

const Share = ({ url, title, twitterhandle, hashtags }) => {
  console.log('>>>', url, title, twitterhandle, hashtags)
  if (!url || !title) {
    return null
  }
  return (
    <div className="mx-auto p-8">
      <p className="text-xs">Compartir</p>

      <BorderRed />

      <div className="mx-auto flex items-center justify-center">
        <FacebookShareButton
          url={url}
          quote={title}
          className="h-8 w-8 flex items-center justify-center">
          <img src={facebookicon} alt="" />
        </FacebookShareButton>
        <TwitterShareButton
          url={url}
          title={title}
          via={twitterhandle}
          hashtags={hashtags}
          className="rounded-full h-8 w-8 flex items-center justify-center">
          <img src={twittericon} alt="" />
        </TwitterShareButton>
        <WhatsappShareButton
          url={url}
          title={title}
          separator={' '}
          className="rounded-full h-8 w-8 flex items-center justify-center">
          <img src={whatsappicon} alt="" />
        </WhatsappShareButton>
      </div>
    </div>
  )
}

export default Share
